var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.37 5.53002L17.84 5.94202C17.6469 5.994 17.5033 6.15605 17.475 6.35402C17.2988 7.58551 16.244 8.50011 15 8.50002H5.5C5.22386 8.50002 5 8.72388 5 9.00002V9.50002C5 10.8807 6.11929 12 7.5 12H8.75C9.02614 12 9.25 12.2239 9.25 12.5V16.788C9.25014 17.0338 9.07167 17.2432 8.829 17.282L3.079 18.2C2.93455 18.2231 2.78723 18.1818 2.67585 18.087C2.56447 17.9922 2.50021 17.8533 2.5 17.707V16.75C2.5 16.0597 1.94036 15.5 1.25 15.5C0.559644 15.5 0 16.0597 0 16.75V22.75C0 23.4404 0.559644 24 1.25 24C1.94036 24 2.5 23.4404 2.5 22.75V21.25C2.49986 21.0043 2.67833 20.7948 2.921 20.756L9.931 19.639H9.952C10.9969 19.4238 11.7479 18.5058 11.752 17.439V12.5C11.752 12.2239 11.9759 12 12.252 12H19C19.5523 12 20 11.5523 20 11V6.01302C20.0001 5.85743 19.9277 5.71068 19.8042 5.61602C19.6807 5.52135 19.5202 5.48956 19.37 5.53002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.788 0.385008C23.5995 0.141105 23.3082 -0.0011973 23 7.59037e-06H7C5.34315 7.59037e-06 4 1.34315 4 3.00001V6.00001C4 6.55229 4.44772 7.00001 5 7.00001H15C15.5523 7.00001 16 6.55229 16 6.00001V5.26701C15.9999 5.04086 16.1516 4.84281 16.37 4.78401L22.783 3.06001C23.1038 2.97793 23.3589 2.73525 23.457 2.41901L23.97 1.24301C24.0456 0.944258 23.9784 0.627332 23.788 0.385008Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6C21.4477 6 21 6.44772 21 7V9C21 9.55228 21.4477 10 22 10C22.5523 10 23 9.55228 23 9V7C23 6.44772 22.5523 6 22 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.c42c75d0.svg";
export { ForwardRef as ReactComponent };